import styled from 'styled-components';
import { scrollBlueStyles } from '../../../styles/sharedStyles';

export const StyledScrollHeaderPayAll = styled.div`
    width: calc(${({ calcwidth }) => (calcwidth ? '100% - 54px' : '100%')});
    overflow-x: scroll;

    ${scrollBlueStyles};
`;
